module.exports = __webpack_public_path__ + "static/img/2-bg.b765442.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/2-bg.png
// module id = z4Zf
// module chunks = 1